<template>
  <div :class="{ 'notice-bar': true, [type]: true }">
    <div class="notice-bar-content">
      <p class="title">{{ title }}</p>
      <p class="summary">
        <span>{{ summary }}</span>
        <slot></slot>
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  name: 'notice-bar',
})
export default class NoticeBar extends Vue {
  @Prop({ required: true, type: String, default: 'normal' }) public type!: string;
  @Prop({ required: false, type: String }) public title?: string;
  @Prop({ required: false, type: String }) public summary?: string;
}
</script>

<style src="./notice-bar.component.scss" lang="scss" scoped></style>
